import React from 'react'
import { Helmet } from 'react-helmet';
import AppLayoutTitle from './appLayoutTitle';
import ComTable from './../components/comTable';
import { handleException } from '../../helper/helperError';
import { apiGet, apiPost } from '../../helper/helperApi';
import Select from 'react-select';
import { isEmpty, loadFilter, saveFilter } from '../../helper/helperGeneral';
import ComLoading from './../components/comLoading';


const AppEmailHistory = () => {
    const _MAX_PAGE_SIZE = 10;
    const [dataset, setDataset] = React.useState(undefined);
    const [filterOptions, setFilterOptions] = React.useState(undefined);
    const [filter, setFilter] = React.useState(loadFilter("emailHistoryFilter", {
        reportType: "",
        domainId: "",
        pageSize: _MAX_PAGE_SIZE,
        pageNumber: 1,
    }));
    const commonSelectProps = {
        classNamePrefix: "react-select",
        isSearchable: false,
        isClearable: false,
        menuShouldBlockScroll: true,
        onChange: (selected, meta) => { setFilter({ ...filter, [meta.name]: selected.value }); },
        styles: {
            control: (base) => ({ ...base, minHeight: '30px', height: '30px', fontSize: '0.8rem', }),
            option: (base) => ({ ...base, whiteSpace: 'nowrap', }),
            dropdownIndicator: (base) => ({ ...base, padding: 4, }),
            clearIndicator: (base) => ({ ...base, padding: 4, }),
            valueContainer: (base) => ({ ...base, padding: '0 6px', }),
            input: (base) => ({ ...base, margin: 0, padding: 0, }),
            menu: (base) => ({ ...base, fontSize: '0.8rem', width: 'auto', minWidth: '100%', maxWidth: 'none', }),
            menuList: (base) => ({ ...base, padding: 0, }),
        },
    }

    const fetchFilterOptions = async () => {
        if (!filterOptions) {
            apiGet("/reports/getEmailHistoryFilterOptions")
                .then((res) => setFilterOptions(res.data || {}))
                .catch((ex) => handleException(ex, "Failed to fetch filter options for email history"));
        }
    }

    const fetchEmailHistoryData = async () => {
        if (isEmpty(filterOptions)) return;
        setDataset(undefined);
        apiPost("/reports/getEmailHistory", filter)
            .then((res) => setDataset(res.data || []))
            .catch((ex) => handleException(ex, "Failed to fetch email history data"));
    }

    React.useEffect(() => {
        fetchFilterOptions();
    }, []);

    React.useEffect(() => {
        saveFilter("emailHistoryFilter", filter);
        fetchEmailHistoryData();
    }, [filter, filterOptions]);

    if (!filterOptions) return <ComLoading message="Loading data..." />;

    return <>
        <Helmet>
            <title>Email History | Sparkling Email</title>
        </Helmet>
        <>
            <AppLayoutTitle title="Email History" />
            <div className="px-3 py-3">
                <div>
                    Monitor Your Translation / Signature Activity
                </div>
                <div>
                    Quickly access key system reports related to email translation and signature-sending activity. View
                    detailed statistics on sent email requests, translation costs, system usage, and IP addresses.
                    We are committed to retaining the minimal amount of data necessary. All information is aggregated and
                    collected solely for debugging, cost tracking, and administrative purposes.
                    Please note that <span className="bg-light p-1 fw-bold">all logs (email history) are permanently and irreversibly deleted after 90 days.</span>
                    No raw content or additional personal data is stored beyond this scope.
                </div>
                <br />
                <ComTable
                    data={dataset}
                    isUndefinedIsLoading={true}
                    handlePrevPage={(filter.pageNumber > 1) ? () => { setFilter({ ...filter, pageNumber: filter.pageNumber - 1 }) } : undefined}
                    handleNextPage={(dataset && dataset?.length === _MAX_PAGE_SIZE) ? () => { setFilter({ ...filter, pageNumber: filter.pageNumber + 1 }) } : undefined}
                    handleReload={() => { setFilter({ ...filter, pageNumber: 1 }) }}
                    showCopyToClipboard={true}
                    showCompactMode={true}
                    headerLeft={<>
                        <Select
                            {...commonSelectProps}
                            name="domainId"
                            placeholder="Select Domain"
                            options={filterOptions.domainOptions}
                            value={filterOptions.domainOptions.find(opt => opt.value === filter.domainId)}
                        />
                        <Select
                            {...commonSelectProps}
                            name="reportType"
                            placeholder="Select Report Type"
                            options={filterOptions.reportTypeOptions}
                            value={filterOptions.reportTypeOptions.find(opt => opt.value === filter.reportType)}
                        />
                    </>}
                />
            </div>
        </>
    </>
}

export default AppEmailHistory;